import { OktaAuth } from "@okta/okta-auth-js"

export default {
    install(Vue, options) {
        if (!options || !options.issuer || !options.clientId || !options.redirectUri) {
            throw new Error('Missing required options for Okta plugin');
        }

        const oktaAuth = new OktaAuth({
            issuer: options.issuer,
            clientId: options.clientId,
            redirectUri: options.redirectUri,
            scopes: options.scopes || ["openid", "profile", "email"],
            pkce: true,
            dpop: options.dpop || false,
            tokenManager: {
                storage: options.storage || 'localStorage',
                autoRenew: options.autoRenew || true,
                secure: options.secure || true
            }
        });


        Vue.prototype.$auth = oktaAuth;

    }
}